import { Body } from './Body';
import { Button } from './Button';
import { Footer } from './Footer';
import { Header } from './Header';
import { HeaderText } from './HeaderText';
import { Root } from './Root';

export default {
  Root,
  Header,
  Body,
  Footer,
  HeaderText,
  Button,
};
